<template>
  <Dice class="skill" content :dice="dice" :label="label">
    <div class="name">
      <span class="prof-icon" :class="level"></span>
      {{ titleCase(name) }}
    </div>
    <div class="modifier">
      {{ modifier }}
    </div>
  </Dice>
</template>

<script setup lang="ts">
import { titleCase } from '../util'
import { resolveDice, type DiceExpr } from '~/assets/dice/diceEval'

const props = defineProps<{
  name: string
  dice: DiceExpr
  level?: string
  label?: string
}>()

const mods = useMods()

const modifier = computed(() => {
  const dice = ('' + props.dice).replace(/^[0-9]*d20.*?\+/, '')
  const value = resolveDice(dice, mods(), true)
  return value < 0 ? `${value}` : `+${value}`
})
</script>

<style scoped lang="postcss">
.skill {
  display: flex;
  justify-content: space-between;
  padding: 0.1em 0.5em;
  cursor: pointer;

  @media (width < 600px) {
    padding: 0.1em 0.25em;
  }

  &:hover {
    color: var(--text-highlight);
    background: var(--bg-primary);
  }

  .name {
    .prof-icon {
      display: inline-flex;
      justify-content: center;
      position: relative;
      align-items: center;
      width: 10px;
      height: 10px;
      color: var(--text-highlight);
      border: 2px solid currentColor;
      margin-right: 0.5em;
      border-radius: 50%;

      &.custom {
        background: var(--primary);
      }

      &.proficiency,
      &.expertise {
        background: currentColor;
      }

      &.halfproficiency {
        background: linear-gradient(to right, transparent 0%, transparent 50%, currentColor 50%, currentColor 100%);
      }

      &.expertise {
        width: 8px;
        height: 8px;

        &::before {
          display: block;
          position: absolute;
          content: '';
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid currentColor;
        }
      }
    }
  }
  .modifier {
    font-family: var(--font-stack-title);
    color: var(--text-highlight);
  }
}
</style>
